import { gql } from "gql";

export const TRANSLATE_LOCALIZED_VALUE = gql(/* GraphQL */ `
  query TranslateLocalizedValue(
    $value: LocalizedValueInput!
    $context: String
  ) {
    translateLocalizedValue(value: $value, context: $context) {
      ...LocalizedValueDtoFragment
    }
  }
`);
